/* ===========================================================
   ui/AppBar.jsx — the Protocol apps' own names, and Weather
   Protocol's little weather bar (his asks, 2026-11-04: "separate Docs
   and Drive" and "make the home of all new protocol apps have the
   little heading bar of weather protocol")

   APPS: each app's name, icon and address (lib/hosts.js picks the
   address). AppLogo: its tile. WxBar: a slim strip with the weather
   where you are (your home place in Weather Protocol, else roughly
   where your internet says you are), linking to Weather Protocol.
   =========================================================== */

import { useEffect, useState } from 'preact/hooks';
import { api } from '../lib/api.js';
import { session, online } from '../state.js';
import { Icon } from './ui.jsx';

export const APPS = {
  docs:  { name: 'Docs Protocol',  short: 'Docs',  icon: 'doc' },
  notes: { name: 'Notes Protocol', short: 'Notes', icon: 'pencil' },
  drive: { name: 'Drive Protocol', short: 'Drive', icon: 'folder' },
  music: { name: 'Music Protocol', short: 'Music', icon: 'music', owner: true },   // prototype: his account only
};

export function AppLogo({ app = 'docs', size = 28 }) {
  if (app === 'docs') {
    return (
      <span class="logo" aria-hidden="true">
        <svg viewBox="0 0 32 32" width={size} height={size}>
          <rect x="5" y="3" width="22" height="26" rx="4" fill="var(--a)" />
          <path d="M10 11h12M10 16h12M10 21h8" stroke="var(--on-a)" stroke-width="2.4" stroke-linecap="round" />
        </svg>
      </span>
    );
  }
  return (
    <span class={`logo app-logo app-${app}`} aria-hidden="true" style={{ width: `${size}px`, height: `${size}px` }}>
      <Icon name={APPS[app].icon} size={Math.round(size * 0.6)} />
    </span>
  );
}

/* ---------- the weather strip ---------- */

const WMO = c => c === 0 ? 'clear' : c <= 2 ? 'partly cloudy' : c === 3 ? 'cloudy' : c <= 48 ? 'foggy'
  : c <= 57 ? 'drizzle' : c <= 67 ? 'rain' : c <= 77 ? 'snow' : c <= 82 ? 'showers' : c <= 86 ? 'snow showers' : 'storms';
const CACHE = 'dp:wxbar';

async function loadWx() {
  try {
    const c = JSON.parse(sessionStorage.getItem(CACHE) || 'null');
    if (c && Date.now() - c.at < 10 * 60_000) return c;
  } catch { /* fine */ }
  const where = await api('/api/where');
  const w = where?.wx;
  if (!w) return null;
  const us = w.units === 'us';
  const wx = {
    at: Date.now(), name: where.name, home: where.home,
    temp: Math.round(w.temp), feels: Math.round(w.feels), sky: WMO(w.code),
    wind: Math.round(w.wind), windU: us ? 'mph' : 'km/h', rain: Math.round(w.rain),
  };
  try { sessionStorage.setItem(CACHE, JSON.stringify(wx)); } catch { /* private */ }
  return wx;
}

const WP = () => (/(^|\.)weatherprotocol\.org$/.test(location.hostname) ? 'https://weatherprotocol.org/' : 'https://weather-protocol.zane-armstrong222.workers.dev/');

export function WxBar() {
  const [wx, setWx] = useState(null);
  const [time, setTime] = useState(() => new Date());
  useEffect(() => {
    let alive = true;
    if (session.value.user && online.value) loadWx().then(w => { if (alive) setWx(w); }).catch(() => {});
    const t = setInterval(() => setTime(new Date()), 30_000);
    return () => { alive = false; clearInterval(t); };
  }, []);
  const clock = time.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  return (
    <a class="wxbar" href={WP()} title="Open Weather Protocol">
      <span class="wx-place"><Icon name="cloudSun" size={14} />{wx ? wx.name : 'Weather Protocol'}</span>
      {wx && <>
        <span class="wx-item"><span class="wx-k">Temp</span><b>{wx.temp}°</b></span>
        <span class="wx-item hide-xs"><span class="wx-k">Feels</span><b>{wx.feels}°</b></span>
        <span class="wx-item hide-xs"><span class="wx-k">Sky</span><b>{wx.sky}</b></span>
        <span class="wx-item hide-sm"><span class="wx-k">Wind</span><b>{wx.wind} {wx.windU}</b></span>
        <span class="wx-item"><span class="wx-k">Rain</span><b>{wx.rain}%</b></span>
      </>}
      <span class="grow" />
      <span class="wx-live"><span class="wx-dot" />Live</span>
      <span class="wx-clock">{clock}</span>
    </a>
  );
}
